//import React from 'react'
//import { Outlet, Link, NavLink } from "react-router-dom";
//import { useState, useEffect } from "react"
import "98.css";

export default function Gallery({renderGallery, onOpen}) {

    // function minimise(e) {
    //     var selector = e.target;
    //     //console.log(selector);
    //     var tray = document.querySelector('.tray');
    //     var dataName = selector.getAttribute('data-name');
    //     //dataName = '[data-name="' + dataName + '"]';

    //     tray.querySelector('[data-name="' + dataName + '"]').removeAttribute('aria-selected');
    //     selector.closest('.window') && selector.closest('.window').classList.add('hidden');
    // }

    function reOpen(selector) {
        
        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });

        var selector = selector.target;
        //console.log(selector);
        var dataName = selector.getAttribute('data-name');

        document.querySelector('.window-container').append(document.querySelector('.window[data-name="' + dataName +'"]'));

        if (document.querySelector('.window[data-name="' + dataName + '"]')) {
            selector.ariaSelected = 'true';
            document.querySelector('.window[data-name="' + dataName + '"]').classList.remove('hidden');
        }
    }
    
    // function hideContactForm(e) {
    //     var el = e.target;
    //     //console.log(el);
    //     var dataName = el.getAttribute('data-name');
    //     checkTray(el, true);
    //     document.querySelector('.window[data-name="' + dataName + '"]').classList.add('hidden');
    // }

    function checkTray(selector, close=false) {
        var selector = selector;
        //console.log(selector);
        var tray = document.querySelector('.tray');
        var dataName = selector.getAttribute('data-name');

        document.querySelectorAll('.tray button').forEach(item => {
            item.removeAttribute('aria-selected');
        });
        //dataName = '[data-name="' + dataName + '"]';
    
        //console.log(dataName)
        if (!tray.querySelector('[data-name="' + dataName + '"]')) {
            //console.log('not in tray, add it!')

            document.querySelectorAll('.tray button').forEach(item => {
                item.ariaSelected = 'false';
            });
    
            var el = document.createElement('button');
            el.role = "tab";
            el.innerText = dataName;
            //el.insertAdjacentHTML('afterbegin', '<a>' + dataName + '</a>');
            el.ariaSelected = "true";
            el.setAttribute('data-name', dataName);
            el.onclick = reOpen;
            document.querySelector('.tray menu').insertAdjacentElement('beforeend', el);

            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else if (!close) {
            
            document.querySelector('.tray button[data-name="' + dataName +'"]').ariaSelected = 'true';
            
        } else {
            //console.log('already in tray');
            tray.querySelector('[data-name="' + dataName + '"]').remove();
        }
    }

    var images = [
        {id : 0, name : "000008.JPG"},
        {id : 1, name : "Still003.png"},
        {id : 2, name : "Still005.png"},
        {id : 3, name : "Still019.png"},
        {id : 4, name : "Still033.png"},
        {id : 5, name : "IMG_2485.jpg"},
        {id : 6, name : "IMG_2494.jpg"},
        {id : 7, name : "PICT1056.jpg"},
        {id : 8, name : "itatcar.png"},
        {id : 9, name : "IMG_9620-1.jpg"},
        {id : 10, name : "65420014.JPG"},
        {id : 11, name : "65420018.JPG"},
        {id : 12, name : "65420022.JPG"},
        {id : 13, name : "65420027.JPG"},
    ];

    let imageGalleryItems;
    if (renderGallery) {
        imageGalleryItems = images.map(image => 
            <div className="item" key={image.id}><div className="icon image" style={{backgroundImage: "url(/images/gallery2/" + image.name + ")"}} onClick={onOpen} data-name="Photo Viewer" data-photo={image.name}>{image.name}</div></div>
        );
    }
    
    return (
        <>
        
        {imageGalleryItems}

        </> 
    )
}